if (!customElements.get('video-embed')) {
    class VideoEmbed extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.playBtn = this.querySelector('.js-play-btn');
        this.pauseAfter = this.getAttribute('data-pause-after') ? parseInt(this.getAttribute('data-pause-after')) * 1000 : 0;
        this.pauseTimeout = null;
        
        this.initEventListeners();
      }
      
      initEventListeners() {
        if (this.pauseAfter !== 0) {
          this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
          this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        }
        
        this.playBtn?.addEventListener('click', this.handleClick.bind(this));
        this.video?.addEventListener('click', this.handleClick.bind(this));
        
        this.video?.addEventListener('play', this.onVideoPlay.bind(this));
        this.video?.addEventListener('pause', this.onVideoPause.bind(this));
      }
      
      onMouseEnter() {
        if (this.video.paused) {
          this.startPreview();
        }
      }
      
      onMouseLeave() {
        if (this.video.muted && !this.video.paused) {
          this.stopPreview();
        }
      }
      
      handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        
        if (this.video.paused || this.video.muted) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      }
      
      onVideoPlay() {
        if (!this.video.muted) {
          this.playBtn.classList.add('hidden');
        }
      }
      
      onVideoPause() {
        this.playBtn.classList.remove('hidden');
        clearTimeout(this.pauseTimeout);
      }
      
      startPreview() {
        clearTimeout(this.pauseTimeout);
        
        this.video.muted = true;
        this.video.currentTime = 0;
        
        this.video.play();
        
        if (this.pauseAfter > 0) {
          this.pauseTimeout = setTimeout(() => {
            this.stopPreview();
          }, this.pauseAfter);
        }
      }
      
      stopPreview() {
        clearTimeout(this.pauseTimeout);
        this.video.pause();
        this.video.currentTime = 0;
      }
      
      playVideo() {
        clearTimeout(this.pauseTimeout);
        
        document.querySelectorAll('video').forEach(video => {
          if (video !== this.video) video.pause();
        });
        
        this.video.muted = false;
        this.video.currentTime = 0;
        
        this.playBtn.classList.add('hidden');
        
        this.video.play();
      }
      
      pauseVideo() {
        this.video.pause();
        clearTimeout(this.pauseTimeout);
      }
    }

    customElements.define('video-embed', VideoEmbed);
  }